// 登录
import request from "@/utils/request";

export function getToken(code) {
    return request({
        url: '/api/weixin/getToken',
        method: 'get',
        params: code
    })
}


export default {getToken}
